import { StandardTextFieldProps, TextField } from '@mui/material';

interface ISearchInputProps extends StandardTextFieldProps {
  forceUpdate?: (e: any) => void;
}

export const SearchInput = ({ children, forceUpdate, ...props }: ISearchInputProps) => (
  <TextField
    {...props}
    sx={{
      minWidth: { mobile: 120, tablet: 350, laptop: 200 },
      ...props.sx
    }}
    variant={'standard'}
    onInput={(e) => document.activeElement !== e.target ? forceUpdate?.(e) : undefined}
    onBlur={forceUpdate}
  >
    {children}
  </TextField>
);